import VueRouter from "vue-router";
import routes from "./routes";

// configure router
const router = new VueRouter({
    routes
});

export default router;
